var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.heading)?_c('h2',{staticClass:"gl-font-lg gl-mt-0"},[_vm._v(_vm._s(_vm.heading))]):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.$scopedSlots.list)?_c('ul',{staticClass:"gl-list-style-none gl-gap-y-3 gl-p-0"},[_vm._t("list")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }